import styles from './SideMenu.module.scss';
import { UserModel } from '@shared/models/userModels';
import Group, { GroupProps } from '@shared/components/Group/Group';

export interface SideMenuProps {
  elements: GroupProps[];
  userData?: UserModel;
}

const SideMenu = (props: SideMenuProps) => {
  const { elements, userData } = props;

  return (
    <nav className={styles.wrapper}>
      {elements.map((item, mainIndex) => (
        <Group {...item} key={mainIndex} userData={userData} />
      ))}
    </nav>
  );
};

export default SideMenu;
